import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Store, select } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { JwtService } from "src/app/shared/services/jwt.service";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  invokeClienByHashedId,
  invokeUpdateClient,
  resultClientByHashedId,
  resultCreateUpdateClient,
} from "src/app/store/clientIberis/clientIberis.actions";
import { CommonParamsIberis } from "src/app/shared/models/iberis/paramsForGetAll";
import { ResultListClientsFromIberis } from "src/app/shared/models/iberis/client/resultListClientFromIbris";
import {
  loadingClientSelector,
  resultClientByHashedIdSelector,
} from "src/app/store/clientIberis/clientIberis.selectors";
import { CreateClient } from "src/app/shared/models/iberis/client/createClient";
import { ResultCreateClient } from "src/app/shared/models/iberis/client/resultCreateClient";
import { resultCreateUpdateClientSelector } from "src/app/store/clientIberis/clientIberis.selectors";
import {
  invokeMarkEstimate,
  invokeUpdateEstimate,
} from "src/app/store/commande/commande.actions";
import { createEstimate } from "src/app/shared/models/iberis/commande/createEstimate";
import { AdDetailsInterface } from "src/app/shared/models/advertising-campaigns/ad-details.interface";
import { ResultCreateEstimate } from "src/app/shared/models/iberis/commande/resultCreateEstimate";
import { resultUpdateEstimateSelector } from "src/app/store/commande/commande.selectors";
import { Router } from "@angular/router";
import {
  invokeIdIberis,
  invokeUpdateAdvertiser,
} from "src/app/store/advertiser/advertiser.actions";
import {
  advertiserProfileDetailsSelector,
  resultIdIberisSelector,
} from "src/app/store/advertiser/advertiser.selectors";
import { environment } from "src/environments/environment";
import { RoleEnum } from "src/app/shared/models/user/role.interface";
import {
  invokeUpdateBillingsInfo,
  resultUpdateBillingsInfo,
} from "src/app/store/user/user.actions";
import { BillingInfoRequest } from "src/app/shared/models/user/billingInfoRequest";
import { resultUpdateBillingsInfoSelector } from "src/app/store/user/user.selectors";
import { AdvertiserDetailsInterface } from "src/app/shared/models/advertiser/profile.interface";
import { LPInfo } from "src/app/shared/models/location-partners/lpInfo";
import { resultLPInfoSelector } from "src/app/store/locationPartner/location-partner.selectors";
import { FranchiseProfileInterface } from "src/app/shared/models/franchise/franchise-profile.interface";
import { resultFranchiseInfoSelector } from "src/app/store/franchise/franchise.selectors";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
@Component({
  selector: "app-billing-info",
  templateUrl: "./billing-info.component.html",
})
export class BillingInfoComponent extends BaseComponent implements OnInit {
  @Input() totalFields: number;
  @Input() clientId: string | null;
  @Input() createEstimate: createEstimate;
  @Input() adDetails: AdDetailsInterface;
  billingInfoForm: FormGroup<any>;
  billingInfoSuccessMessage$: Observable<SuccessDto | null>;
  missingFieldsPercentage: number = 0;
  email: string;
  params: CommonParamsIberis = {
    lang: "fr",
    companyId: environment.IBERIS.IBERIS_COMPANY_ID,
  };
  client$: Observable<ResultListClientsFromIberis | null>;
  client: ResultListClientsFromIberis | null;
  newInformation: CreateClient;
  resultUpdateClient$: Observable<ResultCreateClient | null>;
  resultUpdateClient: ResultCreateEstimate | null;
  resultUpdateEstimate$: Observable<ResultCreateEstimate | null>;
  resultUpdateEstimate: ResultCreateEstimate | null;
  isProfile: boolean | null;
  idIberis$: Observable<string | null>;
  loading$: Observable<boolean | null>;
  loading: boolean | null;

  @Input("billingDetails") billingDetails: Observable<BillingInfoRequest>;
  billingInfo: BillingInfoRequest;
  role: RoleEnum;
  updateBillings$: Observable<SuccessDto | null>;
  profileDetails$: Observable<AdvertiserDetailsInterface | null>;
  profileLocationPartner$: Observable<LPInfo | null>;
  franchiseProfile$: Observable<FranchiseProfileInterface | null>;

  constructor(
    private store: Store<AppStateInterface>,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private translate: TranslateService,
    private jwtService: JwtService,
    private route: Router,
    private saveHistory: SaveUserHistoryService
  ) {
    super(store);
    this.client$ = this.store
      .pipe(select(resultClientByHashedIdSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.resultUpdateClient$ = this.store
      .pipe(select(resultCreateUpdateClientSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.resultUpdateEstimate$ = this.store
      .pipe(select(resultUpdateEstimateSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.idIberis$ = this.store
      .pipe(select(resultIdIberisSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.loading$ = this.store
      .pipe(select(loadingClientSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.updateBillings$ = this.store
      .pipe(select(resultUpdateBillingsInfoSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.profileDetails$ = this.store
      .pipe(select(advertiserProfileDetailsSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.profileLocationPartner$ = this.store
      .pipe(select(resultLPInfoSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.franchiseProfile$ = this.store
      .pipe(select(resultFranchiseInfoSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.billingInfoForm = this.fb.group({
      legalName: [null],
      taxRegistration: [null],
      billingAddress: [null],
    });
    this.role = this.jwtService.getRoleName(this.jwtService.getToken());
    this.route.events.subscribe((event) => {
      this.isProfile = this.route.url.includes("/profile");
    });
    this.email = this.jwtService.getEmail();
  }

  ngOnInit(): void {
    this.profileDetails$.subscribe((data) => {
      if (data) {
        this.billingInfo = data;
        this.billingInfoForm.patchValue({
          legalName: data.legalName,
          taxRegistration: data.taxRegistration,
          billingAddress: data.billingAddress,
        });
      }
    });
    this.profileLocationPartner$.subscribe((data) => {
      if (data) {
        this.billingInfo = data;
        this.billingInfoForm.patchValue({
          legalName: data.legalName,
          taxRegistration: data.taxRegistration,
          billingAddress: data.billingAddress,
        });
      }
    });
    this.franchiseProfile$.subscribe((data) => {
      if (data) {
        this.billingInfo = data;
        this.billingInfoForm.patchValue({
          legalName: data.legalName,
          taxRegistration: data.taxRegistration,
          billingAddress: data.billingAddress,
        });
      }
    });
    this.store.dispatch(resultUpdateBillingsInfo({ successMessage: null }));
    this.store.dispatch(resultCreateUpdateClient({ createClient: null }));
    this.store.dispatch(
      resultClientByHashedId({ resultClientByHashedId: null })
    );
    this.loading$.subscribe((data) => {
      this.loading = data;
    });
    this.idIberis$.subscribe((result) => {
      if (result) {
        this.clientId = result;
      } else {
        if (
          this.jwtService.getRoleName(this.jwtService.getToken()) ==
          RoleEnum.ROLE_ADVERTISER
        ) {
          this.store.dispatch(invokeIdIberis({email: this.email}));
        }
      }
    });

    this.client$.subscribe((data) => {
      if (data != null) {
        this.client = data;
        const billing = this.client.data.client.billing;
        const billingObj = JSON.parse(billing);
        const delivery = this.client.data.client.delivery;
        const deliveryObj = JSON.parse(delivery);
        const newBillingAddress =
          this.billingInfoForm.get("billingAddress")?.value;
        this.newInformation = {
          first_name: this.client.data.client.first_name,
          last_name: this.client.data.client.last_name,
          company: this.client.data.client.organisation,
          display_name: this.client.data.client.display_name,
          delivery_address: deliveryObj.address,
          delivery_country: environment.IBERIS.COUNTRY_ID,
          delivery_state: "",
          delivery_zip: "", //code postal
          bill_address: billingObj.address,
          bill_country: environment.IBERIS.COUNTRY_ID,
          bill_state: "",
          bill_zip: "",
          email: this.client.data.client.email,
          fiscal_id: this.client.data.client.fiscal_id,
          phone: this.client.data.client.phone,
          note: this.client.data.client.note,
          website: this.client.data.client.website,
          activity_id: this.client.data.client.hashed_activity_id,
          currency_id: this.client.data.client.hashed_currency_id,
          deadline_id:
            this.client.data.client.hashed_default_invoice_deadline_id,
          title: this.client.data.client.title,
          reference: this.client.data.client.reference,
          price_list_id: environment.IBERIS.PRICE_ID,
        };
        if (newBillingAddress) {
          this.newInformation.bill_address = newBillingAddress;
          this.newInformation.delivery_address = newBillingAddress;
        }
        if (this.billingInfoForm.get("legalName")?.value) {
          this.newInformation.company =
            this.billingInfoForm.get("legalName")?.value;
        }
        if (this.billingInfoForm.get("taxRegistration")?.value) {
          this.newInformation.fiscal_id =
            this.billingInfoForm.get("taxRegistration")?.value;
        }
        this.store.dispatch(
          invokeUpdateClient({
            params: this.params,
            updateClient: this.newInformation,
            idClient: this.clientId,
          })
        );
      }
    });
    this.updateBillings$.subscribe((data) => {
      if (data) {
        this.loading = false;
        this.toastr.success(
          this.translate.instant("response.success." + data.message),
          this.translate.instant("response.successTitle")
        );
      }
    });
    this.resultUpdateClient$.subscribe((data) => {
      if (data) {
        this.loading = false;
        this.store.dispatch(resultCreateUpdateClient({ createClient: null }));
        if (this.isProfile == false) {
          this.store.dispatch(
            invokeUpdateEstimate({
              params: this.params,
              createEstimate: {
                ...this.createEstimate,
                estimate_number: this.adDetails.estimateNumber.substring(
                  this.adDetails.estimateNumber.lastIndexOf("-") + 1
                ),
              },
              estimateId: this.adDetails.estimateId,
            })
          );
        }
      }
    });
  }
  submitBilling() {
    this.loading = true;
    if (this.role == RoleEnum.ROLE_ADVERTISER) {
      this.store.dispatch(
        invokeClienByHashedId({ params: this.params, clientId: this.clientId })
      );
    }
    this.store.dispatch(
      invokeUpdateBillingsInfo({ billingRequest: this.billingInfoForm.value })
    );
    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.PATCH,
      UserHistoryServicesEnum.UPDATE_BILLING
    );
  }
}
